// @flow
import styled from "styled-components";
import buildColor from "../../_static/ColorPalette";

export const Container = styled.div`
  background-color: ${buildColor("white", "100")};
`;
